import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import {
  saveReceipts,
  saveReceiptsFailure,
  clearAjaxCall
} from '../../actions/Receipts'

import Modal from '../Modal'
import { validMail } from '../Utils/Service'
import { paymentTypes } from '../../options.json'

class EditReceipt extends Component {
  saveReceipts() {
    const r = this.state
    if (
      r.account_holder === '' ||
      r.amount === '' ||
      (r.id !== null &&
        (r.number === '' || r.account_holder === '' || r.amount === ''))
    ) {
      this.props.saveReceiptsFailure('Tutti i dati sono obbligatori')
      setTimeout(() => {
        this.props.clearAjaxCall('')
      }, 3000)
    } else {
      this.props.saveReceipts({
        id: r.id,
        number: r.number !== '' ? r.number : r.cumulative,
        account_holder: r.account_holder,
        amount: r.amount,
        causal: r.causal,
        emission_date:
          r.emission_date !== ''
            ? moment.utc(r.emission_date).startOf('day').unix()
            : '',
        payment_mode:
          r.payment_mode !== '' ? r.payment_mode : paymentTypes[0].value,
        subscription: r.subscription !== '' ? r.subscription : null,
        notes: r.notes,
        send_mail: this.canBeMailed(r.account_holder) ? r.send_mail : false,
        regenerate_pdf: r.regenerate_pdf
      })
    }
  }
  canBeMailed() {
    let cur = (this.props.members.list || []).filter((obj) => {
      return obj.id === parseInt(this.state.account_holder, 10)
    })[0]
    if (cur !== undefined) {
      return validMail(cur.email)
    }
    return false
  }
  componentWillMount() {
    const r = this.props.receipt
    const ll = this.props.receipts.list
    let causal = ''
    if (r.id === null) {
      if (ll !== null && ll.length > 0) {
        const last = ll.filter((item) => {
          return item.subscription === r.subscription
        })
        if (last.length > 0) {
          causal = last[0].causal
        }
      }
    } else {
      causal = r.causal
    }
    this.setState({
      id: r.id,
      number: r.number > 0 ? r.number : r.cumulative,
      account_holder: r.account_holder,
      amount: r.amount,
      causal: causal,
      emission_date:
        r.emission_date !== ''
          ? moment.unix(r.emission_date).format('YYYY-MM-DD')
          : moment().format('YYYY-MM-DD'),
      payment_mode: r.payment_mode,
      subscription: r.subscription,
      notes: r.notes,
      send_mail: false,
      regenerate_pdf: r.id === null
    })
  }
  render() {
    const { ajaxStatus } = this.props.receipts
    const { list } = this.props.members
    const r = this.state
    return (
      <Modal>
        <h3>
          {r.id !== null ? 'Modifica' : 'Nuova'}&nbsp;
          {r.subscription ? 'quota associativa' : 'ricevuta'}
        </h3>
        <button
          className='lnk-close-modal'
          onClick={() => this.props.hideModal()}
        >
          <i className='fa fa-times' aria-hidden='true'></i>
        </button>
        <label>
          Numero ricevuta &nbsp;
          {r.id === null &&
            '(lasciare vuoto se deve essere generata automaticamente)'}
          <input
            type='text'
            onChange={(event) => this.setState({ number: event.target.value })}
            value={r.number}
          />
        </label>
        <label>
          Importo
          <input
            type='number'
            placeholder='Importo'
            onChange={(event) => this.setState({ amount: event.target.value })}
            value={r.amount}
          />
        </label>
        <label>
          Intestatario
          <select
            onChange={(event) =>
              this.setState({ account_holder: event.target.value })
            }
            value={r.account_holder}
          >
            <option value=''></option>
            {list !== null &&
              // .filter((item) => {
              //   return (r.subscription) ? (item.active.toString() === 'false') : (item.active.toString() === 'true')
              // }).
              list
                .sort((a, b) => {
                  return a.surname > b.surname
                    ? 1
                    : b.surname > a.surname
                    ? -1
                    : 0
                })
                .map((m, index) => {
                  return (
                    <option key={index} value={m.id}>
                      {m.surname} {m.name}
                    </option>
                  )
                })}
          </select>
        </label>
        <label>
          Causale
          <input
            type='text'
            placeholder='Causale'
            onChange={(event) => this.setState({ causal: event.target.value })}
            value={r.causal}
          />
        </label>
        <label>
          Data emissione
          <input
            type='date'
            placeholder='Data emissione'
            // disabled={r.id !== null}
            onChange={(event) =>
              this.setState({ emission_date: event.target.value })
            }
            value={r.emission_date}
          />
        </label>
        <label>
          Modalità pagamento
          <select
            onChange={(event) =>
              this.setState({ payment_mode: event.target.value })
            }
            value={r.payment_mode}
          >
            {paymentTypes.map((i, index) => {
              return (
                <option key={index} value={i.value}>
                  {i.label}
                </option>
              )
            })}
          </select>
        </label>
        <label>
          Note
          <textarea
            placeholder='Note'
            onChange={(event) => this.setState({ notes: event.target.value })}
            value={r.notes}
          ></textarea>
        </label>
        {this.canBeMailed() && (
          <label className='check-container'>
            Invia ricevuta via mail
            <input
              type='checkbox'
              onChange={(event) =>
                this.setState({ send_mail: event.target.checked })
              }
              value={r.send_mail}
            />
            <span className='checkmark'></span>
          </label>
        )}
        {r.id !== null && (
          <label className='check-container'>
            Rigenera PDF ricevuta
            <input
              type='checkbox'
              onChange={(event) =>
                this.setState({ regenerate_pdf: event.target.checked })
              }
              checked={r.regenerate_pdf}
              value={r.regenerate_pdf}
            />
            <span className='checkmark'></span>
          </label>
        )}
        <ul className='submit-btn'>
          <li>
            <span className='ajax-error'>{ajaxStatus}</span>
          </li>
          <li>
            <button
              className='lnk-submit'
              onClick={() => this.props.hideModal()}
            >
              annulla
            </button>
          </li>
          <li>
            <button className='lnk-submit' onClick={() => this.saveReceipts()}>
              salva
            </button>
          </li>
        </ul>
      </Modal>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {
  saveReceipts,
  saveReceiptsFailure,
  clearAjaxCall
})(EditReceipt)



// WEBPACK FOOTER //
// ./src/components/Receipts/EditReceipt.js